/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Videos_CreateInputs */

const en_settings_videos_create = /** @type {(inputs: Settings_Videos_CreateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Make a rap video`)
};

/**
* | output |
* | --- |
* | "Make a rap video" |
*
* @param {Settings_Videos_CreateInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const settings_videos_create = /** @type {((inputs?: Settings_Videos_CreateInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Videos_CreateInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_settings_videos_create(inputs)
});
export { settings_videos_create as "settings.videos.create" }